export default {
  title: 'KFF - Custom State Reports',
  text: 'Custom State Report',
  twitter: {
    via: '@kff',
    hashtags: '',
  },
  summary: 'Custom State Reports via KFF',
  source: 'Kaiser Family Foundation',
};



// WEBPACK FOOTER //
// ./app/config/shareConfig.js